import { cn } from '@/lib/utils'

import { LevelPlayStartBadge } from './LevelPlayStartBadge'

const QUIZ_INTRO_TEXT =
  'Responda perguntas, teste seu conhecimento sobre o evento e ganhe recompensas!'

export interface LevelPlayStartCardQuizProps {
  name: string
  className?: string
}

export const LevelPlayStartCardQuiz = ({
  name,
  className
}: LevelPlayStartCardQuizProps) => (
  <div
    className={cn(
      'w-full max-w-[400px] rounded-xl border border-gray-200 bg-white p-3 shadow-sm',
      className
    )}
  >
    <div className="flex items-stretch gap-3">
      <div className="flex aspect-square w-24 shrink-0 self-start overflow-hidden rounded-lg">
        <img
          src="/quizzes/art1.png"
          alt=""
          className="h-full w-full object-contain"
        />
      </div>

      <div className="min-w-0 flex flex-1 flex-col items-start gap-2">
        <LevelPlayStartBadge kind="quiz" size="sm" className="self-start" />

        <span className="text-sm font-bold leading-snug text-[#1e2139]">
          {name}
        </span>

        <p className="m-0 text-sm leading-snug text-gray-700">
          {QUIZ_INTRO_TEXT}
        </p>
      </div>
    </div>
  </div>
)
